module.exports = __webpack_public_path__ + "static/img/react.84e54aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sources/logos/react.png
// module id = 38Sv
// module chunks = 1